import { render, staticRenderFns } from "./fileUploadResumeTable.vue?vue&type=template&id=587577a2&scoped=true&"
import script from "./fileUploadResumeTable.vue?vue&type=script&lang=js&"
export * from "./fileUploadResumeTable.vue?vue&type=script&lang=js&"
import style0 from "./fileUploadResumeTable.vue?vue&type=style&index=0&id=587577a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587577a2",
  null
  
)

export default component.exports